module.exports = __webpack_public_path__ + "static/salon-pasajeros---iluminacion-c04e7d23fbde817c1c938dea6bf50034.jpg";